import { apiUrl } from "../../config";
import { getViewportSize } from "../HtmlUtils";
import { getEnvVar } from "../../config/RuntimeConfig";

export const PASSENGER_PLATE = 'PASSENGER';
export const MOTORCYCLE_PLATE = 'MOTORCYCLE';
export const ENGLISH_SLOGAN = '0000';
export const NO_GRAPHIC = '0000';
export const GRAPHIC = '9999';
export const DEFAULT_PLATE_CHARACTERS = '00AA00';

export const GRAPHIC_TYPES = {
  '0001': 'Toronto Blue Jays',
  '0002': 'Toronto Argos',
  '0004': 'Toronto Raptors',
  '0005': 'Hamilton Tiger Cats',
  '0007': 'Ottawa Senators',
  '0009': 'Trillium',
  '0010': 'Road Safety: It Starts With You',
  '0011': 'Wilfred Laurier University',
  '0012': 'Scout Canada',
  '0013': 'Heart',
  '0014': 'I Heart',
  '0015': 'Ontario Lacrosse Association',
  '0016': 'Queen\'s University',
  '0017': 'Ontario Federation Of Snowmobiles',
  '0018': 'Shriners International',
  '0019': 'Radio Amateurs Of Canada',
  '0021': 'University Of Toronto',
  '0023': 'Elmer The Elephant',
  '0024': 'Canadian National Sportsman Show',
  '0025': 'Oddfellows And Rebekas',
  '0026': 'Anishinabek Nation',
  '0027': 'Ontario SPCA',
  '0029': 'Knights Of Columbus',
  '0031': 'Girl Guides Of Canada,',
  '0032': 'Ontario Federation Of Angliers And Hunters',
  '0033': 'Don\'t Drink And Drive',
  '0034': 'Canadian Flag',
  '0035': 'Fire Service Society',
  '0037': 'Ontario Square And Round Dancing Federation',
  '0038': 'Association Of Canadian Distillers',
  '0039': 'Ducks Unlimited',
  '0040': 'Taekwon-Do Federation',
  '0041': 'University Of Waterloo',
  '0042': 'Kawartha Lakes',
  '0043': 'Lincoln And Welland Regiment',
  '0044': 'Lions International',
  '0046': 'Royal Canadian Legion',
  '0047': 'Queens Own Rifles Of Canada',
  '0048': 'Rotary Club International',
  '0049': 'Ontario Veteran',
  '0050': 'Fire Service Society',
  '0051': 'Trillium',
  '0052': 'Loon',
  '0054': 'Toronto Maple Leafs',
  '0055': 'Franco-Ontarian',
  '0057': 'Ontario Paramedics Association',
  '0058': 'Royal Regiment Of Canadian Artillery',
  '0059': 'Lakehead University',
  '0060': 'Trillium Gift Of Life Network',
  '0061': 'Gov Gen Horse Guards Association',
  '0062': 'Queens York Rangers',
  '0063': 'Army Cadet League Of Canada (Ontario)',
  '0064': 'Ottawa Valley Adventure Playground',
  '0065': 'Royal Regiment Of Canada',
  '0066': 'Royal Hamilton Light Infantry',
  '0067': 'Toronto Scottish Regiment',
  '0068': 'Nishnawbe Aski Nation',
  '0069': 'Farley Foundation',
  '0070': 'Special Olympics',
  '0071': 'Canadian Blood Services',
  '0072': '48th Highlanders',
  '0073': 'Canadian Blood Services',
  '0074': 'Ontario Professional Fire Fighters',
  '0075': 'St. John Ambulance',
  '0076': 'Franco Ontarian',
  '0077': 'Niagara 1812 Bicentennial',
  '0085': 'Professional Engineers Ontario',
  '0084': 'Breast Cancer Society Canada',
  '0080': 'Grand Lodge AF & AM Of Canada',
  '0056': 'Ontario Flag',
  '0081': 'Cadet Instructor Cadre',
  '0079': 'Equine Canada',
  '0083': 'Support Our Troops',
  '0082': 'MADD Canada (Mothers Against Drunk Driving)',
  '0078': 'Canadian Snowbird Assoication',
  '0087': 'Geocaching',
  '0090': 'United Empire Loyalists',
  '0089': 'Ontario Veterinary Technicians',
  '0091': 'Ottawa Redblacks',
  '0092': 'The Royal Canadian Regiment',
  '0093': 'Canadian Tire Jumpstart',
  '0094': 'George Brown College',
  '0096': 'Loon',
  '0097': 'Trillium',
  '0098': 'Canadian Flag',
  '0099': 'Heart',
  '0100': 'J\'Heart',
  '0101': 'Ontario Flag',
  '0102': 'Ottawa Senators',
  '0103': 'Toronto Maple Leafs',
  '0104': 'Veteran',
  '0105': 'Fire Service Society',
  '0106': 'Toronto Raptors',
  '0107': 'Toronto Blue Jays',
  '0108': 'Support our Troops',
  '0109': 'Girl Guides of Canada',
  '0110': 'Scouts Canada',
  '0111': 'Equine Canada',
  '0112': 'Grand Lodge A.F. & A.M. of Canada',
  '0113': 'Lakehead University',
  '0114': 'Shriners International',
  '0115': 'Ontario Federation of Snowmobile Clubs',
  '0116': 'Elmer the Safety Elephant',
  '0117': 'Professional Engineers Ontario',
  '0118': 'Royal Hamilton Light Infantry',
  '0119': 'St. John Ambulance',
  '0120': 'Association Of Canadian Distillers',
  '0121': 'Breast Cancer Society of Canada',
  '0122': 'Royal Regiment of Canada',
  '0123': 'Lincoln & Welland Regiment Foundation',
  '0124': 'Ontario Square and Round Dance Federation',
  '0125': 'Royal Canadian Legion Ontario Command',
  '0126': 'United Empire Loyalists Association of Canada',
  '0127': 'Royal Regiment of Canadian Artillery',
  '0128': 'Don\'t Drink and Drive',
  '0129': 'Toronto Argonauts',
  '0130': 'Wilfrid Laurier University',
  '0131': 'Ottawa Valley Adventure Playground',
  '0132': 'Knights of Columbus',
  '0133': 'Queens University',
  '0134': 'Ontario Lacrosse Association',
  '0135': 'Canadian National Sportsmen\'s Show',
  '0136': 'Grand Lodge of Ontario Independent Order of Oddfellows',
  '0137': 'Ducks Unlimited',
  '0138': 'International Ch\'ang-Hon Taekwon-Do Federation',
  '0139': 'University of Waterloo',
  '0140': 'Kawartha Lakes Associated Chamber of Commerce',
  '0141': 'Lions Club International',
  '0142': 'Queens own Rifles',
  '0143': 'Rotary International',
  '0144': 'Ontario Paramedic Association',
  '0145': 'Ontario Federation of Anglers and Hunters',
  '0146': 'Trillium Gift of Life',
  '0147': 'Governor General\'s Horse Guards Association',
  '0148': 'Queens York Rangers',
  '0149': 'Toronto Scottish Regiment',
  '0150': 'Nishnawbe Aski Nation',
  '0151': 'Farley Foundation',
  '0152': '48th Highlanders',
  '0153': 'Ontario Professional Fire Fighters Association',
  '0154': 'Geocaching',
  '0155': 'Ottawa Redblacks',
  '0156': 'Canadian Tire Jumpstart Charities',
  '0157': 'George Brown College',
  '0158': 'Radio Amateurs of Canada',
  '0159': 'MADD Canada (Mothers Against Drunk Driving)',
  '0160': 'Hamilton Tiger-Cats',
  '0161': 'University of Toronto',
  '0162': 'Anishinabeck Nation',
  '0163': 'Road Safety Starts with You',
  '0164': 'Army Cadet League of Canada',
  '0166': 'Kinsmen Club Of Goderich'
}
export const SLOGANS = {
  '0000': 'YOURS TO DISCOVER',
  '0001': 'TANT À DÉCOUVRIR'
}

export const getGraphicType = (code: string): string => {
  return code ? GRAPHIC_TYPES[code] : null;
}

export const getSlogan = (code: string): string => {
  return code ? SLOGANS[code] : null;
}

export const constructPlateCanvasAltText = (plateCharacters: string, plateType: string, sloganCode: string, graphicCode: string, isEnglish: boolean): string => {
  if (isEnglish) {
    if (plateType === MOTORCYCLE_PLATE) {
      return 'License plate showing the personalized plate message reading "' + plateCharacters + '".';
    } else if (graphicCode === NO_GRAPHIC) {
      return 'License plate showing personalized text reading "' + plateCharacters + '". The bottom of the plate has the "' + SLOGANS[sloganCode] + '" slogan.';
    } else {
      return 'License plate showing the selected ' + GRAPHIC_TYPES[graphicCode] + ' graphic on the left side and personalized text reading "' + plateCharacters + '", on the right side. The bottom of the plate has the "' + SLOGANS[sloganCode] + '" slogan.';
    }
  } else {
    if (plateType === MOTORCYCLE_PLATE) {
      return 'Plaque d\'immatriculation affichant le texte personnalisé «' + plateCharacters + '».';
    } else if (graphicCode === NO_GRAPHIC) {
      return 'Plaque d\'immatriculation affichant le texte personnalisé «' + plateCharacters + '». Le bas de la plaque comporte le slogan «' + SLOGANS[sloganCode] + '».';
    } else {
      return 'Plaque d\'immatriculation affichant le graphique ' + GRAPHIC_TYPES[graphicCode] + ' sélectionné sur le côté gauche et le texte personnalisé «' + plateCharacters + '» sur le côté droit. Le bas de la plaque comporte le slogan «' + SLOGANS[sloganCode] + '».';
    }
  }
}

export const renderPlateImage = (plateType: string, sloganChoice: string, graphicChoice: string, plateNumber: string, elementId: number) => {
  const imgDomain = apiUrl();
  const fontType = new FontFace("AN-16-037", "url(" + imgDomain + "/assets/fonts/AN-16-037.woff2)", {
    style: "normal",
    weight: "400",
    stretch: "condensed",
  });
  document.fonts.add(fontType);
  fontType.load()  // Has to wait till the font is loaded before redrawing the plate-image.
    .then(() => {
      redrawElements(plateType, sloganChoice, graphicChoice, plateNumber, elementId);
    })
    .catch(err => {
      console.log('Error loading font:', fontType);
    });
}
    
export const redrawElements = (plateType: string, sloganChoice: string, graphicChoice: string, plateNumber: string, elementId: number) => {
  const viewPortSize = getViewportSize();
  const mediaBreakpoint = 440;

  // <div id={`plate-image_${field.Id}`} style={{ position: 'relative', width: '400px', height: '200px' }}>
  const divElement = document.createElement('div');
  divElement.id = `plate-image-${elementId}`;
  const divElementStyle = {
    position: 'relative',
    width: viewPortSize.width < mediaBreakpoint ? '300px' : '400px', 
    height: viewPortSize.width < mediaBreakpoint ? '150px' : '200px'
  };
  Object.assign(divElement.style, divElementStyle);

  // <img src={url}	alt="License Plate Background" style={{ width: '100%', height: '100%' }}/>
  const imgElement = document.createElement('img');
  divElement.appendChild(imgElement);
  const imgDomain = getEnvVar('LAYOUT_API_URL');
  const url = `${imgDomain}/assets/images/${plateType}_${sloganChoice}_${graphicChoice}.png`;
  imgElement.src = url;
  imgElement.alt = 'License Plate Background';
  const imgElementStyle = {
		width: viewPortSize.width < mediaBreakpoint ? '80%' : '100%',
    height: viewPortSize.width < mediaBreakpoint ? '80%' : '100%'
  };
  Object.assign(imgElement.style, imgElementStyle);

  const SVG_NS = "http://www.w3.org/2000/svg";

  // <svg viewBox="0 0 400 200" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
  const svgElement = document.createElementNS(SVG_NS, 'svg');
  divElement.appendChild(svgElement);
	svgElement.setAttribute("viewBox", viewPortSize.width < mediaBreakpoint ? "0 0 350 175" : "0 0 400 200");
  const svgElementStyle = {
    position: 'absolute',
    top: 0, left: 0, 
    width: viewPortSize.width < mediaBreakpoint ? '87.5%' : '100%', 
    height: viewPortSize.width < mediaBreakpoint ? '87.5%' : '100%'
  };
  Object.assign(svgElement.style, svgElementStyle);

  // <text x="200" y="145" textAnchor="middle" fontSize="110" fill="#0080C0" fontFamily="AN-16-037" font-weight="bold">
  //   (plate-characters)
  // </text>
  const textElement = document.createElementNS(SVG_NS, "text");
  svgElement.appendChild(textElement);
  if (!graphicChoice || graphicChoice === '0000') {
		textElement.setAttributeNS(null, "x", viewPortSize.width < mediaBreakpoint ? "160" : "200"); // X-coordinate
  } else {
		textElement.setAttributeNS(null, "x", viewPortSize.width < mediaBreakpoint ? "200" : "245"); // X-coordinate
  }
	textElement.setAttributeNS(null, "y", viewPortSize.width < mediaBreakpoint ? "110" : "140"); // Y-coordinate
  textElement.setAttributeNS(null, "text-anchor", "middle"); // Center alignment
	textElement.setAttributeNS(null, "font-size", viewPortSize.width < mediaBreakpoint ? "88" : "105");
  textElement.setAttributeNS(null, "fill", "#0080C0");
  textElement.setAttributeNS(null, "font-family", "AN-16-037");
  textElement.setAttributeNS(null, "font-weight", "bold");
  textElement.textContent = plateNumber?.toUpperCase();

  const plateContainer = document.getElementById(`plate-image-summary-${elementId}`);
  const previousDivContainer = document.getElementById(`plate-image-${elementId}`);
  if (previousDivContainer) {  // Remove the previous <div>
    previousDivContainer.remove();
  }
  plateContainer.appendChild(divElement);
}